import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Kairos admin module — `/kairos` on console.francisquini.ai.
 *
 * Dashboard 3.3 (Tier 3) — shareables: card templates, generated card
 * instances, share links, receipts + attribution chain, and viral
 * k-factor / share-rate metrics.
 * Spec: `docs/cockpit/dashboards/tier-3-decision-quality.md §3.3`.
 *
 * Surface is `'admin'` — registered only on the console host. Each page
 * also wraps `<RequireAdmin>` for defence-in-depth.
 */
export const manifest: ModuleManifest = {
  module_id: 'kairos',
  display_name: 'Kairos',
  surface: 'admin',
  routes: [
    {
      path: '/kairos',
      component: () =>
        import('@/modules/kairos').then((m) => ({ default: m.KairosHomePage })),
      title: 'Kairos — Dashboard',
      permissions: [],
    },
    {
      path: '/kairos/templates',
      component: () =>
        import('@/modules/kairos').then((m) => ({
          default: m.KairosTemplatesPage,
        })),
      title: 'Kairos — Templates',
      permissions: [],
    },
    {
      path: '/kairos/templates/$id',
      component: () =>
        import('@/modules/kairos').then((m) => ({
          default: m.KairosTemplateEditPage,
        })),
      title: 'Kairos — Editar template',
      permissions: [],
    },
    {
      path: '/kairos/cards',
      component: () =>
        import('@/modules/kairos').then((m) => ({
          default: m.KairosCardInstancesPage,
        })),
      title: 'Kairos — Cards',
      permissions: [],
    },
    {
      path: '/kairos/cards/$id',
      component: () =>
        import('@/modules/kairos').then((m) => ({
          default: m.KairosCardDetailPage,
        })),
      title: 'Kairos — Detalhe do card',
      permissions: [],
    },
    {
      path: '/kairos/share-links',
      component: () =>
        import('@/modules/kairos').then((m) => ({
          default: m.KairosShareLinksPage,
        })),
      title: 'Kairos — Share links',
      permissions: [],
    },
  ],
}
